module.exports = __webpack_public_path__ + "static/media/smartphone.0aeb5677.svg";